import type {SelectOptionItem} from '@yandex-delivery/blocks'
import {i18n} from 'src/shared/config'

export const enum OfferDeliveryType {
  Now = 'now',
  ToTime = 'toTime',
}

export const deliveryTypes: SelectOptionItem<string>[] = [
  {
    value: OfferDeliveryType.Now,
    label: i18n('create.due_requirement.now', 'Сейчас'),
  },
  {
    value: OfferDeliveryType.ToTime,
    label: i18n('create.due-requirement.to_time', 'Ко времени'),
  },
]
